import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d117d84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "page-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "为了您的账户安全，请及时修改密码！", -1))

import NavMenu from '@/components/nav-menu.vue'
import NavHeader from '@/components/nav-header.vue'
import { ref ,onMounted,onUnmounted} from 'vue'
import { useStore } from '@/store'
import { isResetPassword } from '@/service/account/account'
import router from '@/router'

export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const dialogVisible = ref(false)
const isCollapse = ref(false)
const handleFoldChange = (isFold: boolean) => {
  isCollapse.value = isFold
}
const store = useStore()
const onScroll = (e: Event) => {
  const scrollTop = (e.target as HTMLElement).scrollTop
  store.commit('system/updateScrollPosition', scrollTop)
}
const confirmChangePassword = () => {
  dialogVisible.value = false;
  // 跳转到修改密码页面（根据实际路由配置调整）
  router.push({
    path: '/main/employee/updatePassword'
  });

}
const isResetPwd = async () => {
  let empNo = store.state.login.userInfo.empNo;
  await isResetPassword(empNo).then((res) => {
          console.log('打开弹窗',res)

    if (res == true) {
      dialogVisible.value = true;
    }
  })
}
const intervalId = ref();
//加载
onMounted(async () => {
    // 设置定时器,定时保存
    intervalId.value = setInterval(  isResetPwd, 5 * 60 * 10000);
    isResetPwd()
});
onUnmounted(() => {
    if (intervalId.value) {
        clearInterval(intervalId.value);
    }
});


return (_ctx: any,_cache: any) => {
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { class: "main-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_aside, {
          width: isCollapse.value ? '60px' : '210px'
        }, {
          default: _withCtx(() => [
            _createVNode(NavMenu, { collapse: isCollapse.value }, null, 8, ["collapse"])
          ]),
          _: 1
        }, 8, ["width"]),
        _createVNode(_component_el_container, { class: "page" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_header, { class: "page-header" }, {
              default: _withCtx(() => [
                _createVNode(NavHeader, { onFoldChange: handleFoldChange })
              ]),
              _: 1
            }),
            _createVNode(_component_el_main, {
              class: "page-content",
              onScrollPassive: onScroll
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_router_view)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "安全提醒",
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("取 消")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirmChangePassword
        }, {
          default: _withCtx(() => [
            _createTextVNode("确 定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})